import React from "react";
import { ArrowLeftIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Navbar } from "../../components/common/Navbar";
import {
  SettingsAvatarSection,
  SettingsProfileSection,
  SettingsPasswordSection,
} from "../../components/settings";

export const SettingsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <div className="bg-[#eeeff6] w-full min-h-screen flex flex-col">
      {/* Navbar */}
      <Navbar />

      {/* Main Content with top padding to account for fixed navbar */}
      <main className="pt-[70px] px-4 sm:px-6 pb-6 flex-1">
        <div className="w-full max-w-[1392px] mx-auto mt-4 sm:mt-8 bg-white rounded-[21px] border-b border-[#f0eff0] p-4 sm:p-8 min-h-[700px]">
          <div className="max-w-2xl mx-auto">
            <div className="flex items-center gap-4 mb-6 sm:mb-8">
              <Button
                onClick={handleBackToDashboard}
                variant="ghost"
                className="flex items-center gap-2 text-[#373e46] hover:bg-gray-100 p-2 rounded-lg w-auto"
              >
                <ArrowLeftIcon className="w-5 h-5" />
              </Button>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#373e46]">
                Pengaturan Akun
              </h2>
            </div>

            {/* Avatar Section */}
            <SettingsAvatarSection />

            {/* Edit Profile Section */}
            <SettingsProfileSection />

            {/* Change Password Section */}
            <SettingsPasswordSection />
          </div>
        </div>
      </main>
    </div>
  );
};
